<template>
  <div class="protocol-bd tb" v-if="funcView.firmware_task_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.firmware_task_add">
          <el-button type="primary" @click="addFirmwareTask">
            <i class="icon icon-add"></i>
            {{ funcView.firmware_task_add }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.firmware_task_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_firmwareTask.rwmcrwTopic')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item label="Modem SN">
          <el-input v-model="formSearch.modemSn"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_firmwareTask.ji_shen_hao')">
          <el-input v-model="formSearch.bodyNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_firmwareTask.xie_yi_ming_cheng')">
          <el-input v-model="formSearch.protocolName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_firmwareTask.TCPban_ben')">
          <el-input v-model="formSearch.tcpVersion"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_firmwareTask.qi_dong_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="searchDate"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_firmwareTask.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_firmwareTask.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_firmwareTask.zi_yuan_ming_cheng')">
          <el-input v-model="formSearch.firmwareCode"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        :index="true"
        :data="protocolItemList"
        :column="tableColumn"
        height="100%"
        :slots="['taskName', 'taskDesc', 'checkDetail', 'taskStatus', 'protocolName', 'action']"
        @filter="filterChange"
        @sort="sortChange"
      >
        <template v-slot:protocolName="scope">{{ scope.row.protocolName }} / {{ scope.row.tcpVersion }}</template>
        <template v-slot:taskStatus="scope">
          {{ getDicValue('iot_cmd_task_status', scope.row.taskStatus) }}
          ({{ $t('dms_firmwareTask.zong') }}:{{ scope.row.taskDeviceNum }}, {{ $t('dms_firmwareTask.dai_zhi_xing') }}:{{ scope.row.taskWaitNum }}, {{ $t('dms_firmwareTask.zhi_xing_zhong') }}:{{ scope.row.taskExecutingNum }}, {{ $t('Common.com_success') }}:{{ scope.row.taskSuccessNum }},
          {{ $t('Common.com_fail') }}:{{ scope.row.taskFailedNum }}), {{ $t('dms_firmwareTask.yi_qu_xiao') }}:{{ scope.row.taskCancelNum }}
        </template>

        <template slot="checkDetail" slot-scope="scope">
          <span v-if="funcView.firmware_task_content" style="color: #00a2df; cursor: pointer" @click="taskContentDetail(scope.row)">{{ $t('Common.com_detail') }}</span>
          <span v-else>{{ $t('Common.com_detail') }}</span>
        </template>
        <template slot="taskName" slot-scope="scope">
          <span v-if="funcView.firmware_task_status_detail" style="color: #00a2df; cursor: pointer" @click="seeDetailBtn(scope.row)">{{ scope.row.taskName }}</span>
          <span v-else>{{ scope.row.taskName }}</span>
        </template>

        <!-- <template v-slot:taskName="scope">
          <span
            @click="seeDetailBtn(scope.row)"
            style="color:#00a2df; cursor: pointer"
          >{{ scope.row.taskName }}</span>
        </template>
         -->
        <template v-slot:taskDesc="scope">
          <el-popover placement="bottom" width="200" trigger="hover" v-if="scope.row.taskDesc">
            {{ scope.row.taskDesc }}
            <i class="icon icon-banbenxinxi" slot="reference" style="color: #2aafff; font-size: 16px"></i>
          </el-popover>
        </template>

        <template slot="action" slot-scope="scope">
          <span></span>
          <!-- && scope.row.taskStatus!== 3  成功是不能编辑  删除-->
          <el-button
            v-if="funcView.firmware_task_edit && btnAuth(scope.row.taskStatus, 'edit') && (!!isPfHqAdmin || userId === scope.row.creatorId)"
            type="text"
            size="mini"
            @click="editFirmwareTask(scope.row)"
          >
            {{ funcView.firmware_task_edit }}
          </el-button>
          <el-button
            v-if="funcView.firmware_task_remove && btnAuth(scope.row.taskStatus, 'del') && (!!isPfHqAdmin || userId === scope.row.creatorId)"
            type="text"
            size="mini"
            @click="deleteBtn(scope.row.taskName, scope.row.taskId)"
          >
            {{ funcView.firmware_task_remove }}
          </el-button>
          <el-button
            v-if="funcView.firmware_task_cancel && btnAuth(scope.row.taskStatus, 'cancel') && (!!isPfHqAdmin || userId === scope.row.creatorId)"
            type="text"
            size="mini"
            @click="onCancel(scope.row)"
          >
            {{ funcView.firmware_task_cancel }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 固件任务状态  -->
    <!-- <firmware-status-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getTaskList"
    ></firmware-status-dialog> -->
    <!-- 固件任务详情 -->
    <firmwareTask-detail-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTaskList"></firmwareTask-detail-dialog>
    <task-content-dialog :model="dialogModel3" v-if="dialogVisible3" @close="dialogVisible3 = false"></task-content-dialog>
  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
// import firmwareStatusDialog from './children/firmwareTask_status_dialog';
import firmwareTaskDetailDialog from './children/firmwareTask_detail_dialog';
import taskContentDialog from './children/firmwareTask_task_content_dialog';

export default {
  name: 'firmwareTask',
  mixins: [resetFormSearchMixins],
  components: {
    // firmwareStatusDialog,
    firmwareTaskDetailDialog,
    taskContentDialog,
  },
  computed: {
    searchDate: {
      get() {
        if (this.formSearch.taskStartTime) {
          return [this.formSearch.taskStartTime, this.formSearch.taskStartEndTime];
        }
        return '';
      },
      set(val) {
        if (val && val.length) {
          this.formSearch.taskStartTime = val[0];
          this.formSearch.taskStartEndTime = val[1];
        } else {
          this.formSearch.taskStartTime = '';
          this.formSearch.taskStartEndTime = '';
        }
      },
    },
    // 是否总部管理员
    userId() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.userId;
    },
    // 是否总部管理员
    isPfHqAdmin() {
      const userInfo = this.$store.state.userInfo || {};
      return (userInfo.bizType === 'PF' || userInfo.bizType === 'HQ') && userInfo.isAdmin === 1;
    },
  },
  data() {
    return {
      provide: true,
      tableCode: 'firmware_task',
      protocolItemList: [],
      isLoading: false,
      // 分页
      formSearch: {
        search: '',
        taskName: '',
        pageSize: 50,
        pageNum: 1,
        // 高级搜索
        productCode: '',
        protocolName: '',
        tcpVersion: '',
        topicCode: '',
        taskStartTime: '',
        taskStartEndTime: '',
        firmwareCode: '',
        modemSn: '',
        bodyNum: '',
      },
      totalRows: null,
      // 固件任务状态弹窗
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},

      // 任务状态
      // dialogVisible1: false,
      // dialogModel1: {
      //   data: {}
      // },
      // 任务详情
      dialogVisible2: false,
      dialogModel2: {
        data: {},
      },

      // 任务内容
      dialogVisible3: false,
      dialogModel3: {},
      link: null,
    };
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  activated() {
    this.isLoading = true;
    this.getTaskList();
    // 配置任务跳转过来
    if (this.getJump('seeStack')) {
      this.dialogModel2.title = this.$t('dms_firmwareTask.ckrwxx');
      this.dialogModel2.type = 'seeDetail';
      this.dialogVisible2 = true;
      this.dialogModel2.data = this.$route.query;
    }
  },

  methods: {
    addFirmwareTask() {
      this.clearTagByKeep('firmwareTask_item');
      this.jump('/redirect/iot/firmwareTask/add', { parentPath: '/iot/firmwareTask' });
    },
    editFirmwareTask(row) {
      this.clearTagByKeep('firmwareTask_item');
      this.jump('/redirect/iot/firmwareTask/edit', { taskId: row.taskId, parentPath: '/iot/firmwareTask' });
    },
    taskContentDetail(row) {
      this.dialogModel3 = {
        title: this.$t('dms_firmwareTask.ren_wu_nei_rong'),
        data: row,
      };
      this.dialogVisible3 = true;
    },
    onCancel(row) {
      // 注：已执行完成的设备任务无法取消。  dangerouslyUseHTMLString
      const tips = this.$t('dms_firmwareTask.nqdyqxxzdrwm');
      const bottomTips = this.$t('dms_firmwareTask.zyzxwcdsbrwwfqx');
      const htmlStr = `<div><div>${tips}</div><div>${bottomTips}</div></div>`;
      this.$showConfirm(htmlStr, null, { dangerouslyUseHTMLString: true }).then(() => {
        this.$postJSON(`${apis.commandTaskCancel}/${row.taskId}`, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success',
          });
          this.getTaskList();
        });
      });
    },
    /**
     * 检测是否有权限
     * @param {string} taskStatus 状态值
     * @param {string} type 操作类型 edit | del | cancel
     * @return {boolean} ret
     */
    btnAuth(taskStatus, type) {
      // taskStatus 0-待发布 1-待执行 2-执行中 3-已完成
      const types = {
        edit: [0],
        del: [0],
        cancel: [1, 2],
      };
      const authType = types[type];
      if (authType) {
        return authType.includes(taskStatus);
      }
      return true;
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.commandTaskExport, this.formSearch).then(() => {});
    },
    onSearch() {
      this.getTaskList();
    },
    // 获取产品协议数据
    getTaskList: function () {
      this.$getJSON(apis.commandTaskPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.protocolItemList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 删除固件任务
    deleteBtn: function (name, taskId) {
      const tips = this.$t('dms_firmwareTask.nqdyscxzdrwm');
      const bottomTips = this.$t('dms_firmwareTask.zyzxwcdsbrwwfqx');
      const htmlStr = `<div><div>${tips}</div><div>${bottomTips}</div></div>`;
      this.$showConfirm(htmlStr, null, { dangerouslyUseHTMLString: true })
        .then(() => {
          this.$postJSON(`${apis.commandTaskDelete}/${taskId}`, {}, true).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getTaskList();
          });
        })
        .catch(() => {});
    },
    seeDetailBtn: function (row) {
      this.dialogVisible2 = true;
      this.dialogModel2.data = row;
      this.dialogModel2.title = row.taskName;
      this.dialogModel2.type = 'seeDetail';
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTaskList();
    },
  },
};
</script>

<style lang="scss">
// 修改默认的margin-left

.protocol-bd {
  .aside {
    .title {
      padding: 14px 10px;
      line-height: 24px;
      color: #404040;
      font-weight: bold;
      font-size: 16px;
    }
    .search {
      margin: 0 10px;
    }
    .el-collapse-item__content {
      padding-bottom: 10px;
    }
    .el-collapse {
      border-top: none;
      border-bottom: none;
    }
    .el-collapse-item {
      margin-bottom: 8px;
    }
    .el-collapse-item__header {
      border: 1px solid rgba(228, 228, 228, 1);
      background-color: rgba(240, 243, 249, 1);
      height: 34px;
      line-height: 34px;
      padding-left: 10px;
      color: #404040;
      font-size: 12px;
      font-weight: bold;
    }
    .el-collapse-item__wrap {
      padding: 10px;
      border-left: 1px solid rgba(228, 228, 228, 1);
      border-right: 1px solid rgba(228, 228, 228, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
    }
    .is-current > .el-tree-node__content {
      background-color: #f0f3f9;
    }
  }
  .section {
    .title {
      color: #404040;
      font-size: 16px;
      line-height: 24px;
      padding-top: 10px;
      font-weight: bold;
      i {
        margin-right: 5px;
        color: #404040;
      }
    }
    .info-bd {
      padding: 11px 10px 5px;
      height: 66px;

      .label {
        color: #727272;
        font-size: 12px;
        line-height: 17px;
      }
      .value {
        color: #404040;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
